// Ссылки на документы из соглашения эксперта при первом входе.
export const EXPERT_AGREEMENT_LINKS = {
  userAgreement: "/expert-agreement",
  serviceRules: "/consultation-terms",
  privacyPolicy: "/privacy-policy",
};
